import { render } from "./horizontalStyle.vue?vue&type=template&id=3b92562b"
import script from "./horizontalStyle.vue?vue&type=script&lang=js"
export * from "./horizontalStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__